import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { environment } from '../../../environments/environment';
import { MarkdownPipe } from '../pipes/markdown.pipe';

@Component({
  selector: 'app-legal-modal',
  standalone: true,
  imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose, MatButtonModule, MatProgressSpinnerModule, MarkdownPipe],
  templateUrl: './legal-modal.html',
  styleUrl: './legal-modal.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LegalModalComponent implements OnInit {
  private readonly http = inject(HttpClient);
  private readonly data = inject<{ type: 'terms' | 'privacy' }>(MAT_DIALOG_DATA);

  protected readonly content = signal<string | null>(null);
  protected readonly isLoading = signal(true);
  protected readonly hasError = signal(false);
  protected readonly title = this.data.type === 'terms' ? 'Terms & Conditions' : 'Privacy Policy';

  ngOnInit(): void {
    const url =
      this.data.type === 'terms'
        ? `${environment.apiUrl}/api/legal/terms/`
        : `${environment.apiUrl}/api/legal/privacy/`;

    this.http.get<{ content: string }>(url).subscribe({
      next: (res) => {
        this.content.set(res.content);
        this.isLoading.set(false);
      },
      error: () => {
        this.hasError.set(true);
        this.isLoading.set(false);
      },
    });
  }
}
